import {all, fork} from "redux-saga/effects";
import {takeEvery, put} from "@redux-saga/core/effects"
import {loginError, loginRequest, loginSuccess} from "../reducers/auth/authReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import {PayloadAction} from "@reduxjs/toolkit";
import {LoginRequestPayload} from "../interfaces";
import apiPaths from "../config/apiPaths";
import {setLoading} from "../reducers/app/appReducer";
import {openSnackbar, SnackbarState} from "../reducers/snackbar/snackbarReducer";


function* loginSaga() {
    yield takeEvery(loginRequest.type, function* (action: PayloadAction<LoginRequestPayload>) {
        // Reset dello stato di errore
        yield put({ type: loginError.type, payload: null });

        // Imposta il caricamento a true
        yield put({ type: setLoading.type, payload: true });

        // Effettua la richiesta
        let response: CustomFetchResponse = yield CustomFetch({
            method: "POST",
            url: apiPaths.login,
            data: action.payload,
        });

        if (response.status === 200) {
            yield put({ type: loginSuccess.type, payload: response.data });
            action.payload.callback(false)
            yield put({type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Login Effettuato',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                } as SnackbarState})
        } else {
            yield put({ type: loginError.type, payload: response.data });
            action.payload.callback(false)
            yield put({type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Credenziali errate',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                } as SnackbarState})
        }

        // Fine del caricamento
        yield put({ type: setLoading.type, payload: false });
    });
}


export default function* AuthSaga(){
    yield all(
        [fork(loginSaga)]
    )
}